/**
 * 챕터 관련 API 함수
 */

import type { CourseDetailDto, CreateChapterDto, ChapterResponseDto } from "@repo/types";
import apiClient from "../lib/apiClient";

/**
 * 챕터 수정 요청 DTO
 */
export interface UpdateChapterDto {
  title?: string;
  seq?: number;
}

/**
 * 챕터 생성
 *
 * 엔드포인트: POST /api/course/:courseId/chapter
 * - 필수 필드: title, seq
 *
 * @param courseId - 강의 ID
 * @param data - 챕터 생성 데이터 (title, seq)
 * @returns 생성된 챕터 정보 (ChapterResponseDto)
 * @throws API 요청 실패 시 에러
 */
export const createChapter = async (
  courseId: number,
  data: CreateChapterDto
): Promise<ChapterResponseDto> => {
  try {
    console.log("📤 챕터 생성 요청:", { courseId, data });

    const response = await apiClient.post<ChapterResponseDto>(
      `/course/${courseId}/chapter`,
      data
    );

    console.log("✅ 챕터 생성 성공:", {
      courseId,
      chapterId: response.data.id,
      title: response.data.title,
    });
    return response.data;
  } catch (error) {
    console.error("❌ 챕터 생성 실패:", error);
    throw error;
  }
};

/**
 * 챕터 수정
 *
 * 엔드포인트: PATCH /api/course/:courseId/chapter/:chapterId
 * - 부분 업데이트 지원
 *
 * @param courseId - 강의 ID
 * @param chapterId - 챕터 ID
 * @param data - 챕터 수정 데이터
 * @returns 강의 상세 정보 (업데이트된 챕터 목록 포함)
 * @throws API 요청 실패 시 에러
 */
export const updateChapter = async (
  courseId: number,
  chapterId: number,
  data: UpdateChapterDto
): Promise<CourseDetailDto> => {
  try {
    console.log("📤 챕터 수정 요청:", { courseId, chapterId, data });

    const response = await apiClient.patch<CourseDetailDto>(
      `/course/${courseId}/chapter/${chapterId}`,
      data
    );

    console.log("✅ 챕터 수정 성공:", {
      courseId,
      chapterId,
    });
    return response.data;
  } catch (error) {
    console.error("❌ 챕터 수정 실패:", error);
    throw error;
  }
};

/**
 * 챕터 삭제
 *
 * 엔드포인트: DELETE /api/course/:courseId/chapter/:chapterId
 *
 * @param courseId - 강의 ID
 * @param chapterId - 챕터 ID
 * @returns 강의 상세 정보 (업데이트된 챕터 목록 포함)
 * @throws API 요청 실패 시 에러
 */
export const deleteChapter = async (
  courseId: number,
  chapterId: number
): Promise<CourseDetailDto> => {
  try {
    console.log("📤 챕터 삭제 요청:", { courseId, chapterId });

    const response = await apiClient.delete<CourseDetailDto>(
      `/course/${courseId}/chapter/${chapterId}`
    );

    console.log("✅ 챕터 삭제 성공:", {
      courseId,
      chapterId,
    });
    return response.data;
  } catch (error) {
    console.error("❌ 챕터 삭제 실패:", error);
    throw error;
  }
};

